import { Table, TableRow, TableHeader, TableCell } from "@/components/ui/table";

/*
 * ProjectTableSkeleton component
 * A skeleton loader for the project table
 */
export const ProjectTableSkeleton = () => {
  /* Render */
  return (
    <Table>
      {/* Header */}
      <thead>
        <TableRow>
          <TableHeader>Study</TableHeader>
          <TableHeader>Project</TableHeader>
          <TableHeader>Use case</TableHeader>
          <TableHeader>Status</TableHeader>
          <TableHeader>Author</TableHeader>
          <TableHeader>Last edited</TableHeader>
          <TableHeader></TableHeader>
        </TableRow>
      </thead>

      {/* Body */}
      <tbody>
        {Array.from({ length: 10 }).map((_, index) => (
          <TableRow key={index}>
            <TableCell>
              <div className="flex items-center gap-3">
                <div className="skeleton w-12 h-12 rounded-lg" />
                <div className="flex flex-col gap-2">
                  <div className="skeleton h-4 w-32" />
                  <div className="skeleton h-3 w-20" />
                </div>
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                <div className="skeleton w-3 h-3 rounded-full" />
                <div className="skeleton h-4 w-24" />
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                <div className="skeleton w-3 h-3 rounded-full" />
                <div className="skeleton h-4 w-24" />
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                <div className="skeleton w-3 h-3 rounded-full" />
                <div className="skeleton h-4 w-16" />
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                <div className="skeleton w-3 h-3 rounded-full" />
                <div className="skeleton h-4 w-28" />
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                <div className="skeleton w-3 h-3 rounded-full" />
                <div className="skeleton h-4 w-28" />
              </div>
            </TableCell>
            <TableCell>
              <div className="skeleton h-4 w-4 ml-auto" />
            </TableCell>
          </TableRow>
        ))}
      </tbody>
    </Table>
  );
};
